import type { FC } from 'react'
import React from 'react'
import GoogleSafeIcon from 'src/components/icons/GoogleSafeIcon'
import Logo from 'src/components/icons/Logo'
import RASeal from 'src/components/icons/RASeal'
import { ErrorBoundary } from 'src/ErrorBoundary'

import './style.scss'

const BelowFooter: FC = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content-wrapper">
        <div className="copyright-container">
          <Logo />
          <span className="span-copyright">
            Copyright © 2022, todos os direitos reservados.
          </span>
        </div>
        <div className="safe-container">
          <GoogleSafeIcon />
          <div className="ra-indication">
            <p>Premiação:</p>
            <ErrorBoundary>
              <RASeal />
            </ErrorBoundary>
          </div>
        </div>
      </div>
      <div className="footer-infos-container">
        <span className="footer-infos">
          Tellerina Comércio de Presente e Artigos pra Decoração S. A.- CNPJ:
          84.453.844/0021-21 Endereço: Rua Verbo Divino - Chácara Santo
          Antonio/SÃO PAULO CEP 04.719-901
        </span>
        <span className="footer-infos">
          Clique na opção de WhatsApp para ser atendido
        </span>
      </div>
    </footer>
  )
}

export default BelowFooter
